<template>
  <div class="row">
    <div class="col-12">
      <page-header
        :page="page"
        :has-save="true"
        :has-return="true"
        @onSave="saveEvaluation"
        @onReturn="navigate"
      />

      <section-title :content="page.title" :has-line="true" />

      <evaluation-history-form
        ref="evaluationHistoryForm"
        is-edit
        :model="model"
        :can-edit-date="canEditDate"
        :can-edit-parent-aproval="canEditDetermination"
      />
    </div>
  </div>
</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import alert from "@/mixin/alert.mixin";
import EvaluationHistoryForm from "./components/StudentEvaluationHistoryForm";
import loading from "@/mixin/loading.mixin";
import PageHeader from "@/components/common/page/PageHeader";
import store from "@/store/index";
import { scopes } from "./scopes";

export default {
  name: "StudentEvaluationHistoryEdit",
  data: () => ({
    concatenatedReevaluationTime: [],
    page: {
      icon: "fas fa-file-alt",
      title: "Editar Evaluación",
      routes: ["Inicio", "Estudiante", "Evaluaciones"]
    },
    model: {
      date: null,
      discipline: null,
      administrator: "",
      comment: "",
      documents: [],
      isApprovedByParentFlag: false
    },
    documentTypes: [
      { id: 1, name: "Evaluación" },
      { id: 2, name: "Minuta" }
    ],
    cameFromOutside: false,
    cameFromTab2: false,
    returnTo: { name: "student-evaluation-history" },
    canEditDate: store.getters.HasPermission("evaluation.editDate"),
    canEditDetermination: store.getters.HasPermission(
      "evaluation.changeDetermination"
    )
  }),
  components: {
    SectionTitle,
    PageHeader,
    EvaluationHistoryForm
  },
  computed: {
    fromRoute() {
      return this.$router.app._route.params;
    },
    currentEvaluationId() {
      return this.$store.state["student-evaluation-history"]
        .currentEvaluationId;
    },
    async currentEvaluation() {
      const data = this.$store.getters[
        "student-evaluation-history/getEvaluationById"
      ](this.currentEvaluationId);
      return {
        administrator: data.administeredBy,
        comment: data.comment,
        date: new Date(data.evaluationDate),
        discipline: {
          id: data.disciplineId,
          name: data.disciplineName
        },
        canEdit: !data.cantEdit,
        isApprovedByParentFlag: data.isApprovedByParentFlag,
        reevaluationRequired: data.reevaluationRequired,
        reevaluationTime: data.reevaluationTime,
        reevaluationPeriod: data.reevaluationPeriodId,
        reevaluationPurpose: data.reevaluationPurpose,
        concatenatedEvaluationTime: await this.getConcatenatedReevaluationTime(
          data
        )
      };
    }
  },
  methods: {
    async getConcatenatedReevaluationTime(data) {
      var concatenatedTimeId = `${data.reevaluationTime}-${data.reevaluationPeriodId}`;
      await this.getReevaluationTimes();
      var concatenatedEvaluationTimes = this.concatenatedReevaluationTime.filter(
        x => x.id.toString() == concatenatedTimeId.toString()
      );
      if (concatenatedEvaluationTimes.length > 0) {
        return concatenatedEvaluationTimes[0];
      }
      return { id: null, name: null };
    },
    async getReevaluationTimes() {
      var data = await this.$ApiGet("/api/code/reevaluationtimes");
      this.concatenatedReevaluationTime = data.data;
    },
    getSingleEvaluationHistory() {
      this.$ApiGet(
        "/api/studentevaluation/gethistory?studentSieId=" +
          store.getters["$_student/StudentSie"] +
          "&year=" +
          (this.filters.AcademicYear || 0) +
          "&pageNumber=" +
          this.tableConfig.serverParams.page +
          "&pageSize=" +
          this.tableConfig.serverParams.perPage +
          "&disciplineTypeId=" +
          (this.filters.DisciplineTypeId || 0) +
          "&serviceTypeId=" +
          (this.filters.TypeId || 0) +
          "&source=" +
          (this.filters.Source || 0)
      )
        .then(res => {
          this.rows = res.data.data ? this.formatData(res.data.data) : [];
          this.tableConfig.totalPages = res.data.pageCount;
          this.tableConfig.totalRecords = res.data.totalItemCount;
        })
        .catch(err => {
          this.response = err;
        });
    },
    validateRoute() {
      if (store.state.register != null) {
        this.cameFromOutside = true;
        this.returnTo = { name: `${store.state.register.pathName}` };
      } else if (
        this.$root.$route.params &&
        this.$root.$route.params.toward &&
        this.$root.$route.params.toward.query
      ) {
        let tab = this.$root.$route.params.toward.query.tab;
        if (tab == "Tab2") {
          this.cameFromTab2 = true;
        }
      } else {
        this.cameFromOutside = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async saveEvaluation() {
      const valid = await this.$refs["evaluationHistoryForm"].validation();
      if (valid) {
        try {
          const promises = [...this.saveDocuments(), ...this.deleteFile()];
          Promise.all(promises.map(f => f()));

          if (this.canEditDate || this.canEditDetermination) {
            await this.updateDateAndStatus();
          }

          this.ShowToast(
            "Proceso exitoso.",
            "Los datos fueron guardados exitosamente.",
            "success"
          );

          if (this.cameFromOutside) {
            store.$dispatch("setRegisterEvaluation", this.model);
            this.$router.push(this.returnTo);
          } else if (this.cameFromTab2) {
            this.navigate();
          } else {
            this.$router.push({ name: "student-evaluation-history" });
          }
        } catch ({ response }) {
          if (response.status === 500) {
            const error = response.data.message;
            this.ShowToast("Aviso", error, "error");
          }
        }
      }
    },
    saveDocuments() {
      try {
        return (
          this.model.documents
            .filter(({ id, deleted }) => !id && !deleted)
            .map(({ file, type }) => () =>
              new Promise(async () => {
                let formData = new FormData();
                formData.append("File", file);

                await this.$ApiPost(
                  `api/studentevaluation/${this.currentEvaluationId}/document?documentTypeId=${type.id}`,
                  formData
                );
              })
            ) || []
        );
      } catch ({ response }) {
        if (response) {
          const error = response.data.message;
          this.ShowToast("Aviso", error, "error");
        } else {
          this.ShowToast(
            "Ha ocurrido un error al guardar el/los documento/s.",
            "Error",
            "error"
          );
        }
      }
    },
    deleteFile() {
      try {
        return (
          this.model.documents
            .filter(({ id, deleted }) => id && deleted)
            .map(({ id: studentEvaluationDocumentId }) => () =>
              new Promise(async () => {
                await this.$ApiDelete(
                  `api/studentevaluation/${this.currentEvaluationId}/studentDocument/${studentEvaluationDocumentId}`
                );
              })
            ) || []
        );
      } catch ({ response }) {
        if (response) {
          const error = response.data.message;
          this.ShowToast("Aviso", error, "error");
        } else {
          this.ShowToast(
            "Ha ocurrido un error al eliminar el/los documento/s.",
            "Error",
            "error"
          );
        }
      }
    },
    navigate() {
      if (this.fromRoute.toward != undefined) {
        this.$router.push({ ...this.fromRoute.toward });
      } else {
        this.goBack();
      }
    },
    async getDocuments() {
      try {
        const { data } = await this.$ApiGet(
          `api/studentevaluation/${store.getters["$_student/StudentSie"]}/documents/${this.currentEvaluationId}`
        );

        return data
          ? data.map(
              ({
                content,
                contentType,
                documentName,
                documentTypeId,
                studentEvaluationDocumentId
              }) => {
                const documentType =
                  this.documentTypes.find(x => x.id == documentTypeId) || {};

                return {
                  id: studentEvaluationDocumentId,
                  type: { ...documentType },
                  file: {
                    name: documentName,
                    content,
                    contentType
                  }
                };
              }
            )
          : [];
      } catch {
        return [];
      }
    },
    async updateDateAndStatus() {
      let data = {
        date: new Date(this.model.date),
        approvedByParentFlag: this.model.isApprovedByParentFlag,
        currentEvaluationId: this.currentEvaluationId
      };
      await this.$ApiPost(
        `/api/studentevaluation/updateDateAndStatus`,
        data
      ).catch(err => {
        this.response = err;
      });
    }
  },
  async created() {
    this.validateRoute();

    if (this.currentEvaluationId) {
      const documents = await this.getDocuments();
      Object.assign(this.model, {
        ...(await this.currentEvaluation),
        documents
      });
    } else {
      this.$router.push({ name: "student-evaluation-history" });
    }
  },
  beforeRouteEnter(_, __, next) {
    if (store.getters.HasPermission(scopes.edit)) {
      next();
    }
  },
  beforeRouteLeave(_, __, next) {
    this.$store.dispatch(
      "student-evaluation-history/setCurrentEvaluationId",
      null
    );

    next();
  },
  mixins: [alert, loading]
};
</script>
